var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":"Post"}},[_c('feather-icon',{staticClass:"cursor-pointer",attrs:{"icon":"CheckCircleIcon"},on:{"click":function($event){return _vm.PostEntry(_vm.data.item.id)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }